(() => {
  const timers = document.querySelectorAll('[data-gift-countdown]');
  if (!timers.length) return;

  const key = 'gift-offer-deadline';
  let deadline = Number(sessionStorage.getItem(key));
  if (!deadline || deadline <= Date.now()) {
    deadline = Date.now() + 6 * 60 * 60 * 1000 + 12 * 60 * 1000 + 43 * 1000;
    sessionStorage.setItem(key, String(deadline));
  }

  const render = () => {
    const remaining = Math.max(0, deadline - Date.now());
    const hours = Math.floor(remaining / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    timers.forEach((timer) => {
      timer.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      timer.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
      timer.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
    });
  };

  render();
  window.setInterval(render, 1000);
})();

(() => {
  let previewScrollPosition = null;

  const rememberPreviewScroll = () => {
    previewScrollPosition = { left: window.scrollX, top: window.scrollY };
  };

  const restorePreviewScroll = () => {
    const position = previewScrollPosition;
    previewScrollPosition = null;
    if (!position) return;

    const scrollBack = () => window.scrollTo({ left: position.left, top: position.top, behavior: 'auto' });
    window.requestAnimationFrame(scrollBack);
    window.setTimeout(scrollBack, 80);
    window.setTimeout(scrollBack, 240);
  };

  const eyeIcon = `
    <span class="gift-preview-button__icon" aria-hidden="true">
      <svg viewBox="0 0 20 20" fill="none"><path d="M1.8 10s3-5 8.2-5 8.2 5 8.2 5-3 5-8.2 5-8.2-5-8.2-5Z" fill="currentColor"/><circle cx="10" cy="10" r="2.4" fill="#fff"/></svg>
    </span>`;

  const cartIcon = `
    <span class="gift-cart-button__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none"><path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 2-1.6L20.5 8H6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="10" cy="20" r="1.2" fill="currentColor"/><circle cx="18" cy="20" r="1.2" fill="currentColor"/></svg>
    </span>`;

  const personalizedHeader = `
    <div class="gift-customily-personalized-header">
      <span class="gift-customily-personalized-header__sparkle" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M10.4 2.2c.4 3.7 2.4 5.8 6.2 6.2-3.8.5-5.8 2.5-6.2 6.3-.5-3.8-2.5-5.8-6.3-6.3 3.8-.4 5.8-2.5 6.3-6.2Z" fill="currentColor"/><path d="M18.3 13.4c.2 2.1 1.4 3.2 3.5 3.5-2.1.2-3.3 1.4-3.5 3.5-.3-2.1-1.4-3.3-3.5-3.5 2.1-.3 3.2-1.4 3.5-3.5ZM4.1 15.8c.1 1.2.8 1.9 2 2-1.2.2-1.9.8-2 2.1-.2-1.3-.9-1.9-2.1-2.1 1.2-.1 1.9-.8 2.1-2Z" fill="currentColor"/></svg>
      </span>
      <strong>Personalized</strong>
    </div>`;

  const enhanceButtons = () => {
    const previewButton = document.querySelector('#customily-preview-button');
    const cartButton = document.querySelector('#customily-cart-btn');

    if (previewButton && !previewButton.querySelector('.gift-preview-button__icon')) {
      previewButton.insertAdjacentHTML('afterbegin', eyeIcon);
    }

    if (previewButton && !previewButton.dataset.giftScrollMemory) {
      previewButton.dataset.giftScrollMemory = 'true';
      previewButton.addEventListener('click', rememberPreviewScroll, { capture: true });
    }

    if (cartButton && !cartButton.querySelector('.gift-cart-button__icon')) {
      cartButton.insertAdjacentHTML('afterbegin', cartIcon);
    }

    if (cartButton) {
      cartButton.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && /add to cart/i.test(node.textContent)) {
          const normalizedText = node.textContent.replace(/add to cart/i, 'Add to Cart');
          if (normalizedText !== node.textContent) node.textContent = normalizedText;
        }
      });
      cartButton.querySelectorAll('span:not(.gift-cart-button__icon)').forEach((span) => {
        if (/^\s*add to cart\s*$/i.test(span.textContent) && span.textContent.trim() !== 'Add to Cart') {
          span.textContent = 'Add to Cart';
        }
      });
    }

    const options = document.querySelector('#customily-options');
    if (options && !options.querySelector('.gift-customily-personalized-header')) {
      options.classList.add('gift-customily-options--enhanced');
      options.insertAdjacentHTML('afterbegin', personalizedHeader);
    }

    if (cartButton && !document.querySelector('.gift-product-assurance')) {
      const assurance = document.createElement('div');
      assurance.className = 'gift-product-assurance';
      assurance.innerHTML = `
        <p><span aria-hidden="true">✓</span> Full refund for faulty production. No question asked</p>
        <p><span aria-hidden="true">✓</span> In demand. 737 people bought this in the last 24 hours.</p>`;
      cartButton.insertAdjacentElement('afterend', assurance);
    }
  };

  const enhancePreviewModal = () => {
    const main = document.querySelector('.customily-modal-preview-only .main');
    if (!main || main.classList.contains('gift-customily-confirmation')) return;

    const previewWrapper = main.querySelector('.cl-preview-wrapper');
    const nativeClose = main.querySelector('.customily-close-button');
    if (!previewWrapper || !nativeClose) return;

    if (!nativeClose.dataset.giftScrollRestore) {
      nativeClose.dataset.giftScrollRestore = 'true';
      nativeClose.addEventListener('click', restorePreviewScroll);
    }

    main.classList.add('gift-customily-confirmation');

    const intro = document.createElement('div');
    intro.className = 'gift-customily-confirmation__intro';
    intro.innerHTML = `
      <strong><span aria-hidden="true"><svg viewBox="0 0 20 20"><path d="M1.8 10s3-5 8.2-5 8.2 5 8.2 5-3 5-8.2 5-8.2-5-8.2-5Z" fill="currentColor"/><circle cx="10" cy="10" r="2.4" fill="#fff"/></svg></span> Looks Good to Go?</strong>
      <p>Please double-check your preview to receive your item faster.</p>`;
    main.insertBefore(intro, previewWrapper);

    const trust = document.createElement('div');
    trust.className = 'gift-customily-confirmation__trust';
    trust.innerHTML = `
      <p><span aria-hidden="true">✓</span> Full refund for faulty production. No question asked</p>
      <p><span aria-hidden="true">✓</span> In demand. 737 people bought this in the last 24 hours.</p>`;
    previewWrapper.insertAdjacentElement('afterend', trust);

    const actions = document.createElement('div');
    actions.className = 'gift-customily-confirmation__actions';
    actions.innerHTML = `
      <button type="button" class="gift-customily-confirmation__add"><span aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 2-1.6L20.5 8H6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="10" cy="20" r="1.2" fill="currentColor"/><circle cx="18" cy="20" r="1.2" fill="currentColor"/></svg></span> Add to cart</button>
      <button type="button" class="gift-customily-confirmation__cancel">Close</button>`;
    main.append(actions);

    actions.querySelector('.gift-customily-confirmation__cancel').addEventListener('click', () => nativeClose.click());
    actions.querySelector('.gift-customily-confirmation__add').addEventListener('click', () => {
      previewScrollPosition = null;
      nativeClose.click();
      window.setTimeout(() => document.querySelector('#customily-cart-btn')?.click(), 50);
    });
  };

  enhanceButtons();
  enhancePreviewModal();
  let enhancementScheduled = false;
  new MutationObserver(() => {
    if (enhancementScheduled) return;
    enhancementScheduled = true;
    window.requestAnimationFrame(() => {
      enhancementScheduled = false;
      enhanceButtons();
      enhancePreviewModal();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

(() => {
  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const formatDate = (date) =>
    new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric' }).format(date);

  const formatRange = (start, end) => {
    const sameMonth = start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth();
    if (sameMonth) return `${formatDate(start)}-${end.getDate()}`;
    return `${formatDate(start)}-${formatDate(end)}`;
  };

  const initDeliveryEstimate = (scope = document) => {
    scope.querySelectorAll('.gift-product-delivery:not([data-delivery-ready])').forEach((delivery) => {
      const trigger = delivery.querySelector('[data-delivery-open]');
      const modal = delivery.querySelector('[data-delivery-modal]');
      if (!trigger || !modal) return;

      delivery.dataset.deliveryReady = 'true';
      const today = new Date();
      today.setHours(12, 0, 0, 0);
      const shipsStart = addDays(today, 2);
      const shipsEnd = addDays(today, 3);
      const deliveryStart = addDays(today, 9);
      const deliveryEnd = addDays(today, 13);

      delivery.querySelector('[data-delivery-estimate]').textContent = formatRange(deliveryStart, deliveryEnd);
      modal.querySelector('[data-delivery-placed]').textContent = formatDate(today);
      modal.querySelector('[data-delivery-ships]').textContent = formatRange(shipsStart, shipsEnd);
      modal.querySelector('[data-delivery-delivered]').textContent = formatRange(deliveryStart, deliveryEnd);

      let hideTimer;
      const openModal = () => {
        window.clearTimeout(hideTimer);
        modal.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('gift-delivery-modal-open');
        window.requestAnimationFrame(() => {
          modal.classList.add('is-open');
          modal.querySelector('.gift-delivery-modal__close')?.focus();
        });
      };

      const closeModal = () => {
        modal.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('gift-delivery-modal-open');
        hideTimer = window.setTimeout(() => {
          modal.hidden = true;
        }, 180);
        trigger.focus();
      };

      trigger.addEventListener('click', openModal);
      modal.querySelectorAll('[data-delivery-close]').forEach((button) => button.addEventListener('click', closeModal));
      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeModal();
      });
    });
  };

  initDeliveryEstimate();
  document.addEventListener('shopify:section:load', (event) => initDeliveryEstimate(event.target));
})();
